import { twMerge } from 'tailwind-merge';
import React, { useEffect, useRef } from 'react';
import type { HTMLProps } from 'react';

export interface CheckboxProps extends HTMLProps<HTMLInputElement> {
  variant:
    | 'focused'
    | 'checked'
    | 'unchecked'
    | 'disabled'
    | 'intermediate'
    | 'disabled-checked';
  onClick?: () => void;
  className?: string;
  name?: string;
}
const Checkbox: React.FC<CheckboxProps> = ({
  variant,
  className,
  ...other
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkboxRef = useRef<HTMLInputElement | null | undefined | any>(null);

  const checkboxClassName = twMerge(
    'accent-primary-300 hover:accent-primary-400 focus:outline-none focus:ring focus:ring-primary-100',
    className,
  );

  useEffect(() => {
    if (checkboxRef?.current) {
      switch (variant) {
        case 'intermediate':
          checkboxRef.current.checked = false;
          checkboxRef.current.indeterminate = true;
          break;
        case 'checked':
          checkboxRef.current.checked = true;
          checkboxRef.current.indeterminate = false;
          break;
        case 'unchecked':
          checkboxRef.current.checked = false;
          checkboxRef.current.indeterminate = false;
          break;
        case 'disabled':
          checkboxRef.current.checked = false;
          checkboxRef.current.indeterminate = false;
          checkboxRef.current.disabled = true;
          break;
        case 'disabled-checked':
          checkboxRef.current.checked = true;
          checkboxRef.current.indeterminate = false;
          checkboxRef.current.disabled = true;
          break;
        case 'focused':
          checkboxRef.current.checked = false;
          checkboxRef.current.indeterminate = false;
          break;
        default:
          break;
      }
    }
  }, [checkboxRef, variant]);

  return (
    <input
      ref={checkboxRef}
      type="checkbox"
      className={checkboxClassName}
      {...other}
    />
  );
};

export default Checkbox;
